import OutType from "../../enums/OutType.js";

// @see https://www.mlb.com/glossary/standard-stats/caught-stealing
// A caught stealing occurs when a runner attempts to steal but is tagged out before reaching second base, third base or home plate. This typically happens after a pitch, when a catcher throws the ball to the fielder at the base before the runner reaches it. But it can also happen before a pitch, typically when a pitcher throws the ball to first base for a pickoff attempt but the batter has already left for second.

const classifiesAsCaughtStealing = function(outType) {
    switch (outType) {
        // case OutType.Pickoff.key: //  Similarly, a runner who is picked off while diving back to a base has not been "caught stealing" because he never attempted to steal in the first place.
        case OutType.CaughtStealing.key:
            return true;

        default:
            return false;
    }
};

export default classifiesAsCaughtStealing;